module.exports = __webpack_public_path__ + "static/media/joblist.903b512a.svg";